<div *ngIf='text' class='wrapErr' [class.o-flexCenter]='centerText'>
  <meSvg *ngIf='svgAltText' [svgName]='svgAltText' class='o-mg-r-5'></meSvg>
  <div class='wrapErr__text'>
    <span class='o-colorRed'>{{text}}</span>
    <a *ngIf='link' [routerLink]='link' class='o-link'> Go to create now.</a>
  </div>
  <!--  <ng-content></ng-content>-->
</div>
